import './scss/pages/archive-procedures-policies.scss';
import { searchFilters } from './js/components/search-filters.js';

window.addEventListener( 'DOMContentLoaded', () => {

	searchFilters();

} );

